import { SearchSettings } from '@givebacks/api/query';

import { TableSearchFields } from '../types/searchFieldsTypes';

export const createSearchFields = <T extends SearchSettings>(
  tableSearchFields: TableSearchFields<T>
) => {
  return tableSearchFields;
};

// 1. Would we want to use helper methods for creating the input types and then defining the props
